import { LOCALES } from 'i18n/locales';

export const treeIntl = {
    [LOCALES.ENGLISH]: {
        'treeControls.expandAll': 'Expand all',
        'treeControls.collapseAll': 'Collapse all',
        'treeControls.toggleAll': 'All layers',
        'treeControls.expand': 'Expand ',
        'treeControls.collapse': 'Collapse '
    },
    [LOCALES.WELSH]: {
        'treeControls.expandAll': 'Ehangu popeth',
        'treeControls.collapseAll': 'Dymchwel popeth',
        'treeControls.toggleAll': 'Pob haen',
        'treeControls.expand': 'Ehangu ',
        'treeControls.collapse': 'Cau '
    }
};
